
import { defineComponent } from "vue";
import DxTextBox from "devextreme-vue/text-box";
import DxTextArea from "devextreme-vue/text-area";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import CatalogueSelectControl from "@/components/controls//base/CatalogueSelectControl.vue";

export default defineComponent({
  components: {
    DxTextBox,
    DxTextArea,
    IntegerControl,
    DecimalControl,
    CatalogueSelectControl,
  },
  mixins: [mountComponentMixin],
  props: {
    model: { required: true },
    validationGroup: { required: true },
  },
  methods: {},
  created() {
    this.modelLocal = this.model;
  },
});
